module.exports = __webpack_public_path__ + "img/leftside_300.b50aadb6.png";